import { useMemo } from 'react'
import patternBlocks from 'pobble-components/dist/presentation-utils/pattern-blocks.png'
import patternBoxes from 'pobble-components/dist/presentation-utils/pattern-boxes.png'
import patternCircles from 'pobble-components/dist/presentation-utils/pattern-circles.png'
import patternDots from 'pobble-components/dist/presentation-utils/pattern-dots.png'
import patternFloral from 'pobble-components/dist/presentation-utils/pattern-floral.png'
import patternWavey from 'pobble-components/dist/presentation-utils/pattern-wavey.png'
import patternZigzag from 'pobble-components/dist/presentation-utils/pattern-zigzag.png'

const patterns = {
  blocks: patternBlocks,
  boxes: patternBoxes,
  circles: patternCircles,
  dots: patternDots,
  floral: patternFloral,
  wavey: patternWavey,
  zigzag: patternZigzag
}

const colors = {
  blue: '#00afec',
  green: '#a0be17',
  dark_blue: '#25408f',
  red: '#e94d23',
  purple: '#815fa5'
}

const usePresentationPattern = data =>
  useMemo(() => {
    return !data
      ? null
      : {
          pattern: patterns[data.pattern],
          color: colors[data.color]
        }
  }, [data])

const preloadImage = src => {
  const img = new Image()
  img.src = src
}

const preloadImages = sources => {
  sources.forEach(src => preloadImage(src))
}

export { preloadImages, usePresentationPattern }
